import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import classes from './close-button.module.css';
import ConfirmCancel from 'Common/Components/ConfirmModal/ConfirmModal';

const CloseButton = ({ closeOnClick, hasUpdates = false }) => {
	const [showModal, setShowModal] = useState(false);

	const handleClose = () => {
		if (hasUpdates) {
			setShowModal(true);
		} else {
			closeOnClick();
		}
	};

	const handleProceed = () => {
		setShowModal(false);
		closeOnClick();
	};

	const handleWithdraw = () => {
		setShowModal(false);
	};

	return (
		<>
			<div className={classes['close-button-wrapper']}>
				<Button className={classes['close-button']} variant="outlined" onClick={handleClose}>
					Main Menu
				</Button>
			</div>
            <ConfirmCancel 
                isOpen={showModal} 
                heading="Close and return to Main Menu"
                message="If you close without saving, you will lose any changes. Do you wish to proceed and return to the Main Menu?"
                onProceed={handleProceed}
                onWithdraw={handleWithdraw}
            />
		</>
	);
};

CloseButton.propTypes = {
	closeOnClick: PropTypes.func.isRequired,
	hasUpdates: PropTypes.bool
};

export default CloseButton;
